import type { ComponentProps, ReactNode } from 'react';

import { cn } from '../lib/cn';
import { Title } from './title';

/** 화면 머리말 — 높이 64, 제목 24/600 · 우측 동작 하나 (D2 §5.2 · D150). */
export interface PageHeaderProps extends Omit<ComponentProps<'header'>, 'title'> {
  title: ReactNode;
  /**
   * 제목 아래 한 줄. **쓰지 않는 것이 기본이다**(D5 §8 · D150) — 제목만으로 알 수 없는 조건·결과가
   * 있을 때만 쓴다. 화면이 하는 일을 다시 말하는 부제는 노이즈다.
   */
  description?: ReactNode;
  /**
   * 제목 줄 오른쪽 끝 — 보기 전환(`SegmentedControl`)·화면의 1차 행동 하나가 서는 **유일한 자리**다.
   * 제목과 같은 줄 가운데에 맞춘다.
   */
  actions?: ReactNode;
  /** @default 'h1' — `Title`의 `screen` 기본 태그 */
  titleAs?: 'h1' | 'h2';
}

export function PageHeader({
  title,
  description,
  actions,
  titleAs,
  className,
  ...props
}: PageHeaderProps) {
  const heading = (
    <Title level="screen" as={titleAs}>
      {title}
    </Title>
  );
  const sub =
    description !== undefined ? (
      <p className="text-ink-muted mt-snug measure text-sm">{description}</p>
    ) : null;

  return (
    <header className={cn('flex min-h-16 flex-col justify-center', className)} {...props}>
      {actions ? (
        <div className="gap-card flex flex-wrap items-center justify-between">
          {heading}
          <div className="gap-snug flex shrink-0 items-center">{actions}</div>
        </div>
      ) : (
        heading
      )}
      {sub}
    </header>
  );
}
